module.exports = {

    data() {
        return {
            selectedItem: null,
        }
    },

    methods: {
        selectItem(item) {
            this.selectedItem = item;
            this.$emit('on-selected-item', item)
        }
    }
}